<template>
    <div>
        <ErrorLogShower />
        <Progressbar processType="BnT" :currentStepIndex="3" />

        <div class="contentblock">
            <section class="contentblock__content">
                <div class="shop__fieldgroup shop__fieldgroup--no-separator">
                    <div class="migrol-rt-content" v-html="SuccessMessage"></div>
                </div>
            </section>
        </div>

    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import ErrorLogShower from '../_common/ErrorLogShower'
    import Transaction from '@/models/Transaction'
    import Progressbar from '../_common/Progressbar'

    export default {
        computed: {
            ...mapState([
                'Strings',
                'SuccessMessage',
                'OfferNr'
            ]),
            CurrentTransaction() {
                return Transaction.query().with(['positions.warenempfaenger', 'material', 'deliveryPeriod']).first();
            }
        },
        components: {
            ErrorLogShower,
            Progressbar
        },
        mounted() {
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: 'purchase',
                    shipping_tier: this.CurrentTransaction.deliveryPeriod.displayText,
                    quantity: this.CurrentTransaction.totalAmount,
                    zip: this.CurrentTransaction.positions[0].warenempfaenger.zipcode.toString(),
                    ecommerce: {
                        currency: 'CHF',
                        value: this.CurrentTransaction.material.getTotalPrice(null), // Umsatzgesamt - Brutto
                        transaction_id: this.OfferNr, // Eindeutige TransactionID
                        coupon: this.CurrentTransaction.discountCode, // - Optional - Hier Coupon Code aus dem Checkout hinzuf�gen
                        transaction_type: 'offerte', // z.B.: bestellung oder offerte
                        quantity: this.CurrentTransaction.totalAmount, // Menge
                        zip: this.CurrentTransaction.positions[0].warenempfaenger.zipcode.toString(),
                        items: [{
                            item_name: 'Diesel', // Produktname in Shopsprache - Heiz�l, Holzpellets, Diesel
                            item_id: this.CurrentTransaction.material.material, // �bergeordnete ID f�r Heiz�l, Holzpellets, Diesel da Variante des Produktes noch nicht vorhanden - wenn nicht vorhanden leer
                            price: this.CurrentTransaction.material.getUnitPrice(null) ? parseFloat((this.CurrentTransaction.material.getUnitPrice(null) / 100).toFixed(4)) : null, // Preis per Liter
                            item_brand: 'migrol', // Brand des Produktes - falls nicht vorhanden 'migrol'
                            item_category: 'diesel', // z.B.: Heiz�l, Holzpellets, Diesel
                            item_variant: this.CurrentTransaction.material.name, // Produktvariant, wenn vorhanden (zB.: gelb) Varaint der Produkte erst im Checkout Steps ausw�hlbar - Bitte leer lassen
                            quantity: this.CurrentTransaction.totalAmount // Menge
                        }]
                    }
                });
            }
        },
    };
</script>